import { mapGetters } from 'vuex';

export default {
  props: {
    activity: {
      type: Object,
    },
  },
  data() {
    return {
      isDone: false,
      isTextEllipsis: false,
      isShowMore: false,
    };
  },
  computed: {
    ...mapGetters(['address']),
    moreText() {
      if (this.isShowMore) {
        return this.$t('close');
      } else {
        return this.$t('more');
      }
    },
  },
  watch: {
    address(val) {
      this.fetchActivityStatus(this.activity.activityId, val);
    },
    '$i18n.locale'() {
      this.updateTextEllipsis();
    },
  },
  mounted() {
    this.updateTextEllipsis();
  },
  methods: {
    updateTextEllipsis() {
      this.$nextTick(() => {
        setTimeout(() => {
          this.getHeight();
        }, 50);
      });
    },
    showMore() {
      this.isShowMore = !this.isShowMore;
    },
    getHeight() {
      // 获取元素
      var element = this.$refs.activityDescPc;
      console.log('element', this.$refs);
      console.log('offsetHeight', element.offsetHeight);
      console.log('scrollHeight', element.scrollHeight);
      // 判断是否溢出
      if (element) {
        if (element.offsetHeight < element.scrollHeight) {
          // console.log('文本溢出了，被隐藏了！');
          this.isTextEllipsis = true;
        } else {
          this.isTextEllipsis = false;
          // console.log('文本没有溢出，未被隐藏。');
        }
      }
    },
    async onVerify() {
      await this.fetchActivityStatus(this.activity.activityId, this.address);
      if (!this.isDone) {
        window.open(
          `https://galxe.com/TokenPocket/campaign/${this.activity.activityId}`,
          '_self'
        );
      }
    },
    async fetchActivityStatus(activityId, address) {
      if (!activityId || !address) {
        return;
      }
      // const graphqlEndpoint = 'https://graphigo.prd.galaxy.eco/query';
      const graphqlEndpoint = 'https://forwardtest.mytokenpocket.vip/v1/activities/query';
      // GraphQL查询
      const graphqlQuery = `
        {
          campaign(id: "${activityId}") {
            userParticipants(
              address: "${address}"
              first: 10
            ) {
              totalCount
            }
            participationStatus(
              address: "${address}"
            )
          }
        }
      `;
      try {
        const response = await fetch(graphqlEndpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            query: graphqlQuery,
          }),
        });
        const res = await response.json();
        console.log('fetchActivityStatus', res.data.data.campaign.participationStatus);
        if (
          res.data &&
          res.data.data &&
          res.data.data.campaign.participationStatus &&
          res.data.data.campaign.participationStatus === 'Success'
          ) {
          this.isDone = true;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
